import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as bp from 'view/styles/breakpoints';
import { ThemedLink } from 'view/common/themed-link';

export const HelpObjects = styled.ol`
    ${fonts.xsmall};
    padding: ${token('space.0', '0px')};
    list-style-type: none;
    display: flex;
    flex-direction: column;
    width: 100%;
    ${bp.fromXSmall.css`
        ${fonts.regular};
    `};
`;

export const TopicName = styled(ThemedLink)`
    ${fonts.h400};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    ${bp.fromXSmall.css`
        ${fonts.h500};
    `};
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    & ${HelpObjects} {
        margin: ${token('space.100', '8px')} ${token('space.0', '0px')};
    }
    & ${TopicName} {
        margin-top: ${token('space.0', '0px')};
    }
`;

export const ShowMoreLink = styled(ThemedLink)`
    margin-top: auto;
`;

export const ListItem = styled.li`
    margin-top: ${token('space.0', '0px')};
`;
